import { Component, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { FluidModule } from 'primeng/fluid';
import { LayoutService } from '../../service/layout.service';
import { SplitterModule } from 'primeng/splitter';
import { PanelModule } from 'primeng/panel'; 
import { TableModule } from 'primeng/table';    
import { AppCommonFooter } from '../common/app.common.footer';  
import { AppClientMenu } from './app.client.menu';
import { AppClientTopbar } from '../common/app.client.topbar'
import { TranslateModule } from '@ngx-translate/core'; 


@Component({
    selector: 'app-client-layout',
    standalone: true,
    imports: [CommonModule,  FluidModule, PanelModule, AppClientTopbar, RouterModule, SplitterModule, AppCommonFooter, TableModule, AppClientMenu,TranslateModule],
    template: `<div class="layout-wrapper" [ngClass]="containerClass">
    <app-client-topbar></app-client-topbar> 
    <div class="layout-client-main-container"> 
        <div class="layout-main">  
        <h4 class="font-client-title" >{{ 'clientWelcome' | translate }}</h4> 
        <div class="flex flex-col md:flex-row gap-1">
            <div class="md:w-1/2"> 
                <app-client-menu></app-client-menu> 
            </div>
            <!--<div class="w-full md:w-1/2 max-w-full" > -->
                <div class="p-col-12 w-full" style="max-width: 100%; overflow-x: auto;">
                    <router-outlet></router-outlet>
                </div>
           <!-- </div>-->
        </div>      
       </div> 
    </div>  
    <app-common-footer></app-common-footer>
</div>
<div class="layout-mask animate-fadein"></div>`
})

export class AppClientLayout {
   // overlayMenuOpenSubscription: Subscription;

    menuOutsideClickListener: any;

    //@ViewChild(AppUserSidebar) appSidebar!: AppUserSidebar;

    @ViewChild(AppClientTopbar) appTopBar!: AppClientTopbar;

    panelMenuItems = [
        {
            label: 'Customers',
            icon: 'pi pi-fw pi-table',
            items: [
                {
                    label: 'New',
                    icon: 'pi pi-fw pi-user-plus',
                    items: [
                        {
                            label: 'Customer',
                            icon: 'pi pi-fw pi-plus'
                        },
                        {
                            label: 'Duplicate',
                            icon: 'pi pi-fw pi-copy'
                        }
                    ]
                },
                {
                    label: 'Edit',
                    icon: 'pi pi-fw pi-user-edit'
                }
            ]
        },
        {
            label: 'Orders',
            icon: 'pi pi-fw pi-shopping-cart',
            items: [
                {
                    label: 'View',
                    icon: 'pi pi-fw pi-list'
                },
                {
                    label: 'Search',
                    icon: 'pi pi-fw pi-search'
                }
            ]
        },
        {
            label: 'Shipments',
            icon: 'pi pi-fw pi-envelope',
            items: [
                {
                    label: 'Tracker',
                    icon: 'pi pi-fw pi-compass'
                },
                {
                    label: 'Map',
                    icon: 'pi pi-fw pi-map-marker'
                },
                {
                    label: 'Manage',
                    icon: 'pi pi-fw pi-pencil'
                }
            ]
        },
        {
            label: 'Profile',
            icon: 'pi pi-fw pi-user',
            items: [
                {
                    label: 'Settings',
                    icon: 'pi pi-fw pi-cog'
                },
                {
                    label: 'Billing',
                    icon: 'pi pi-fw pi-file'
                }
            ]
        }
    ];

    constructor(
        public layoutService: LayoutService,
        public renderer: Renderer2,
        public router: Router
    ) {
        /*this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
            if (!this.menuOutsideClickListener) {
                this.menuOutsideClickListener = this.renderer.listen('document', 'click', (event) => {
                    if (this.isOutsideClicked(event)) {
                        this.hideMenu();
                    }
                });
            }

            if (this.layoutService.layoutState().staticMenuMobileActive) {
                this.blockBodyScroll();
            }
        });

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.hideMenu();
        });*/
    }

   /* isOutsideClicked(event: MouseEvent) {
        const sidebarEl = document.querySelector('.layout-user-sidebar');
        const topbarEl = document.querySelector('.layout-menu-button');
        const eventTarget = event.target as Node;

        return !(sidebarEl?.isSameNode(eventTarget) || sidebarEl?.contains(eventTarget) || topbarEl?.isSameNode(eventTarget) || topbarEl?.contains(eventTarget));
    }

    hideMenu() {
        this.layoutService.layoutState.update((prev) => ({ ...prev, overlayMenuActive: false, staticMenuMobileActive: false, menuHoverActive: false }));
        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
            this.menuOutsideClickListener = null;
        }
        this.unblockBodyScroll();
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
*/
    get containerClass() {
        return {
            'layout-overlay': this.layoutService.layoutConfig().menuMode === 'overlay',
            'layout-static': this.layoutService.layoutConfig().menuMode === 'static',
            'layout-static-inactive': this.layoutService.layoutState().staticMenuDesktopInactive && this.layoutService.layoutConfig().menuMode === 'static',
            'layout-overlay-active': this.layoutService.layoutState().overlayMenuActive,
            'layout-mobile-active': this.layoutService.layoutState().staticMenuMobileActive
        };
    }
/*
    ngOnDestroy() {
        if (this.overlayMenuOpenSubscription) {
            this.overlayMenuOpenSubscription.unsubscribe();
        }

        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
        }
    }*/
}